import { render, staticRenderFns } from "./MemberHomeworkDo.vue?vue&type=template&id=3ffaa391&scoped=true&"
import script from "./MemberHomeworkDo.vue?vue&type=script&lang=js&"
export * from "./MemberHomeworkDo.vue?vue&type=script&lang=js&"
import style0 from "./MemberHomeworkDo.vue?vue&type=style&index=0&id=3ffaa391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffaa391",
  null
  
)

export default component.exports